import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const DataListItem = ({ index, name, value, styles }) => {
  const values =
    value && value.constructor === Array
      ? value.map((str, index) => {
          return (
            <div className="data-list-item__string" key={index}>
              {str}
            </div>
          );
        })
      : value;

  return (
    <li className="data-list-item" key={index} style={styles}>
      <div className="data-list-item__name">{name}</div>
      <div className="data-list-item__value">
        {value && value.constructor === Array ? values : value}
      </div>
    </li>
  );
};

DataListItem.propTypes = {
  styles: PropTypes.object,
  name: PropTypes.string,
};

export default DataListItem;
